import { useMemo } from 'react';
import { formatUserStatus } from './selectors/logged-user';
import { UserStatus } from '@common/types/objects';

export const useFormattedUserStatus = (status: UserStatus | null) => {
  return useMemo(() => formatUserStatus(status), [status]);
};
